import React from 'react';

import { Container, Row, Spinner } from 'react-bootstrap';

export default function Loading(props) {
    return (
        <Container fluid>
            <Row className="justify-content-center align-items-center" style={{height: `${props.height}`}}>
                <Spinner className={props.spinner} animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </Row>
        </Container>
    )
}
